import Carousel from "nuka-carousel";
import style from "./login.module.scss";
import { MasterFooter } from "../../../layouts";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../../features/auth/hooks/useAuth";
import { useEffect } from "react";

export const Login = () => {
  const { t } = useTranslation();
  const { login } = useAuth();

  useEffect(() => {
    login();
  }, [login]);

  const defaultControlsConfig = { pagingDotsClassName: "hm-paging-dot" };

  const Welcome = () => (
    <>
      <div className="flex flex-row relative h-full w-full p-32 space-x-8 justify-center">
        <div
          className={`${style.radiusCard} w-full lg:w-[40%]  flex flex-col text-center justify-center  bg-white p-5`}
        >
          <img
            src="/assets/images/Karibu.svg"
            alt=""
            className={`${style.loginLogo}`}
          />
          <h3 className={`${style.loginTitle}`}>
            {t("modules.login.welcome")}
          </h3>

          <span className={`${style.loginSubTitle}`}>
            {t("modules.login.you-will-be-redirected-soon")}
          </span>
        </div>

        <div className={`${style.box} w-[40%] hidden lg:flex `}>
          <>
            <Carousel
              withoutControls={false}
              disableAnimation={false}
              adaptiveHeight={true}
              defaultControlsConfig={defaultControlsConfig}
              renderCenterLeftControls={() => {
                return <></>;
              }}
              renderCenterRightControls={() => {
                return <></>;
              }}
              autoplay={true}
            >
              <div
                className={`${style.trackOrderContainer} p-9 justify-center  text-center`}
              >
                <h4 className={`${style.trackOrderTitle}`}>
                  {t("modules.login.info.buy-cement")}
                </h4>
                <img src="/assets/images/illustration-landing.png" alt="" />
                <br />
                <span className={`${style.trackOrderDetails}`}>
                  {t("modules.login.info.delivery-phrase1")} <br />
                  {t("modules.login.info.delivery-phrase2")}
                  <br />
                  {t("modules.login.info.delivery-phrase3")}
                </span>
              </div>
              <div
                className={`${style.trackOrderContainer} p-9 justify-center text-center`}
              >
                <h4 className={`${style.trackOrderTitle}`}>
                  {t("modules.login.info.order-tracking")}
                </h4>
                <img
                  src="/assets/images/illustration-landing.png"
                  alt=""
                  className="justify-center text-center"
                />
                <br />
                <span className={`${style.trackOrderDetails}`}>
                  {t("modules.login.info.delivery-phrase4")} <br />
                  {t("modules.login.info.delivery-phrase5")} <br />
                  {t("modules.login.info.delivery-phrase6")}
                </span>
              </div>
              <div
                className={`${style.trackOrderContainer} p-9 justify-center text-center`}
              >
                <h4 className={`${style.trackOrderTitle}`}>
                  {t("modules.login.info.order-history")}
                </h4>
                <img src="/assets/images/illustration-landing.png" alt="" />{" "}
                <br />
                <span className={`${style.trackOrderDetails}`}>
                  {t("modules.login.info.delivery-phrase7")} <br />
                  {t("modules.login.info.delivery-phrase8")} <br />
                  {t("modules.login.info.delivery-phrase9")}
                </span>
              </div>
            </Carousel>
          </>
        </div>
      </div>
      <div className=" absolute bottom-0 w-full  ">
        <MasterFooter />
      </div>
    </>
  );

  return <Welcome />;
};
